import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ palette, spacing }) => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    flex: 1,
    margin: '24px 2% 0 34px',
    display: 'flex',
    gap: '32px',
    flexDirection: 'column',
  },
  title: {
    fontFamily: Theme.Typography.FontFamily.DMSans,
    fontWeight: Theme.Typography.FontWeight.Medium,
    fontSize: `${Theme.Typography.FontSize.Large}px`,
    lineHeight: '112.5%',
    color: Theme.Colors.Grayscale.OneThousand,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  subContainer: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '32px',
    flexDirection: 'column',
    border: '1px solid #E3E3E3',
    borderRadius: '8px',
    gap: '24px',
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    alignContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '8px',
  },
  labelTitle: {
    top: '-8px',
    left: '14px',
    padding: '0px 6px',
    position: 'absolute',
    backgroundColor: 'white',
  },
  input: {
    maxWidth: '400px',
  },
  button: {
    color: palette.error.main,
    border: `1px solid ${palette.error.main}`,
    padding: spacing(8, 16),
    margin: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',

    backgroundColor: 'transparent',
    fontSize: spacing(14),
    borderRadius: '75px',

    '&:not(:disabled):hover': {
      opacity: '0.8',
    },

    '&:disabled': {
      cursor: 'not-allowed',
      pointerEvents: 'visible',
      color: palette.gray[32],
      backgroundColor: palette.gray[4],
    },
  },
  buttonRed: {
    background: 'transparent',
    color: palette.error.main,
    border: `1px solid ${palette.error.main}`,

    '&:not(:disabled):hover': {
      background: palette.error.main,
      color: palette.gray[4],
    },

    '&:disabled': {
      border: `1px solid ${palette.error.main}`,
    },
  },
  buttonFullBlue: {
    background: palette.primary.main,
    color: palette.gray[4],
    border: 'none',

    '&:not(:disabled):hover': {
      background: palette.primary.main,
      opacity: '0.8',
    },

    '&:disabled': {
      border: `1px solid ${palette.primary.main}`,
    },
  },
  label: {
    color: palette.gray[64],
    fontSize: spacing(12),
  },
  labelCheckbox: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '6px',
    gap: '4px',
  },
  switchLabel: {
    color: palette.gray[64],
    fontSize: spacing(12),
    width: 'max-content',
    display: 'flex',
    gap: '4px',
  },
  switch: {
    margin: '0',
  },
  switchDiv: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  inputContainer: {
    marginTop: '35px',
    gridColumn: 'span 2',
  },
  subContainerWithInput: {
    padding: '32px',
    paddingBottom: '14px',
    paddingTop: '14px',
  },
}))
